import Swal from "sweetalert2";

export const handleShowErrorPopup = (error, callback) => {
  Swal.fire({
    icon: "error",
    title: error,
    allowOutsideClick: false,
  }).then(({ value }) => {
    if (value) {
      callback();
    }
  });
};
